import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-certificate',
  templateUrl: './certificate.component.html',
  styleUrls: ['./certificate.component.scss']
})
export class CertificateComponent implements OnInit {
  Certificate: string;

  constructor(private location: Location,private route: ActivatedRoute) { }

  ngOnInit(): void {
    const receivedData = this.route.snapshot.paramMap.get('data');
  switch (receivedData) {
    case "TC":
     this.Certificate = 'Transfer Certificate'
     break
    case "LC":
     this.Certificate = 'Leaving Certificate'
      break;  
    case "MC":
      this.Certificate = 'Migration Certificate'
      break;
    case "TS":
      this.Certificate = 'Transcript Certificate'
      break;
    default:
      
      break
  }
  }

  Back(){
    this.goBack();
   }
   goBack(): void {
    this.location.back(); 
  }

}
